import { action } from 'satcheljs';

/**
 * Action to notify that the calendar selection initiated.
 */
const calendarSelectionInitiated = action(
    'calendarSelectionInitiated',
    (calendarId: string, ctx: any) => ({
        calendarId,
        ctx,
    })
);

export default calendarSelectionInitiated;
